<template>
  <base-layout>
    <h1 slot="header">
      {{ `app.pages.subscription` | trans }}
    </h1>
    <a slot="buttons" :href="routes.subscription" class="btn btn-primary">
      <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
      {{ `app.back` | trans }}
    </a>
    <v-app id="vuetify-app" class="no--wrap box box-success">
      <v-container>
        <v-layout align-center justify-center column class="box-body">
          <v-flex xs12>
            <p>
              Wybrano darmowe konto.
              Czy potwierdzasz przejście na darmowy plan?
            </p>
          </v-flex>
          <v-flex xs12>
            <v-btn
                :href="routes.subscription"

                color="warning">
              {{ 'page.subscriptions.go_back_to_subscription_selection' | trans }}
            </v-btn>
            <v-btn
                :loading="loading"
                @click="chooseFree()"
                color="primary">
              {{ 'page.subscriptions.confirm_free' | trans }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-app>
  </base-layout>
</template>

<script>
export default {
  props: {
    routes: Object,
  },
  data: () => ({
    loading: false
  }),
  methods: {
    chooseFree() {
      this.loading = true;
      axios.post(this.routes.choose_free)
          .then(() => {
            window.location.href = this.routes.free_summary;
          }).catch((error) => {
        this.sentryCaptureException(error);
        this.loading = false;
      });
    },
  },
}
</script>
